export enum Locale {
  English = 'en',
  Korean = 'ko',
}



// WEBPACK FOOTER //
// ./src/app/dashboard/enums/locale.enum.ts